enum MappingLevel {
  GLOBAL = "GLOBAL",
  STATE = "STATE",
  COUNTY = "COUNTY",
  MSA = "MSA",
  HCF = "HCF",
}

export { MappingLevel };
